import $ from 'jquery';

const Video = (el) => {
    const $el = $(el);
    const $video = $el.find('video[autoplay]');

    if ($video.length) {
        $video.each(function() {
            let video = this;
            video.muted = true;
            video.playsInline = true;

            let playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.catch(function() {
                    // Retry after a short delay in case iOS blocks it initially
                    setTimeout(function() {
                        video.play().catch(function(){});
                    }, 500);
                });
            }
        });
    }
};

export default Video;
